export default "/images/b05cd4f1254c362cad83ff5772d34a8f.avif";